










import Vue from 'vue';
import { adjustColor, getAvatarURL } from '@/core/utils/utils';

export default Vue.extend({
  name: 'HMMemberIcon',
  props: {
    icon: {
      type: String,
    },
    fullName: {
      type: String,
    },
    color: {
      type: String,
    },
    fontSize: {
      type: Number,
      default: 12,
    },
    size: {
      type: String,
      default: '25px',
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    background() {
      return adjustColor(this.color, 20);
      //return adjustColor(this.color, 20)
    },
    imgUrl() {
      return (
        this.icon ||
        getAvatarURL(
          this.fullName,
          this.color,
          'white',
          this.fontSize,
          this.size
        )
      );
    },
  },
});
